const escapeIcs = value => String(value || '').replace(/\\/g, '\\\\').replace(/\r?\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
const compactDate = value => value.replace(/-/g, '');
const nextDay = value => {
    const date = new Date(`${value}T00:00:00Z`);
    date.setUTCDate(date.getUTCDate() + 1);
    return date.toISOString().slice(0, 10);
};
export const eventCalendarText = message => {
    const event = message.event;
    if (!event?.startDate || event.needsReview) throw new Error('Event needs a date');
    const lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Luckynote//Events//EN', 'BEGIN:VEVENT',
        `UID:message-${message.id}@luckynote.io`, `DTSTAMP:${new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z')}`,
        `SUMMARY:${escapeIcs(message.title)}`];
    if (!event.startTime) {
        lines.push(`DTSTART;VALUE=DATE:${compactDate(event.startDate)}`,
            `DTEND;VALUE=DATE:${compactDate(nextDay(event.endDate || event.startDate))}`);
    } else {
        // Floating local times remain floating when the source supplied no zone.
        const zone = event.timeZone ? `;TZID=${escapeIcs(event.timeZone)}` : '';
        lines.push(`DTSTART${zone}:${compactDate(event.startDate)}T${event.startTime.replace(':', '')}00`);
        if (event.endTime) lines.push(`DTEND${zone}:${compactDate(event.endDate || event.startDate)}T${event.endTime.replace(':', '')}00`);
    }
    if (event.location) lines.push(`LOCATION:${escapeIcs(event.location)}`);
    if (message.body) lines.push(`DESCRIPTION:${escapeIcs(message.body)}`);
    lines.push('END:VEVENT', 'END:VCALENDAR');
    // RFC 5545 physical lines are at most 75 octets, including continuations.
    const encoder = new TextEncoder();
    return lines.map(line => {
        let folded = '', bytes = 0;
        for (const char of line) {
            const size = encoder.encode(char).length;
            if (bytes + size > 75) { folded += '\r\n '; bytes = 1; }
            folded += char; bytes += size;
        }
        return folded;
    }).join('\r\n') + '\r\n';
};
